import { render, staticRenderFns } from "./CmgMobileNutritionDetailsModal.vue?vue&type=template&id=3cb956a0&scoped=true&lang=pug&"
import script from "./cmg-mobile-nutrition-details-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-mobile-nutrition-details-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgMobileNutritionDetailsModal.vue?vue&type=style&index=0&id=3cb956a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb956a0",
  null
  
)

export default component.exports